import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { inject, observer, Provider } from "mobx-react";
import { Link } from "react-router-dom";
import { Button, Checkbox, Dropdown, Form, Grid, Icon, Pagination, Popup } from "semantic-ui-react";
import { AppStore } from "../../stores/app-store";
import { AuthStore } from "../../stores/auth-store";
import { Project } from "../../stores/models/project";
import { ProjectStore } from "../../stores/project-store";
import { ProjectDashboardLayout, Sort, UIStore } from "../../stores/ui-store";
import { UserStore } from "../../stores/user-store";
import { EditorPane } from "../common/editor-pane";
import { LoadingSpinner } from "../common/loading-spinner";
import { ProjectsView } from "./projects-view";

interface IProjectDashboardProps{
	projectStore?: ProjectStore;
	authStore?: AuthStore;
	appStore?: AppStore;
}

interface IProjectDashboardState{
	show: boolean;
	projectName: string;
	projectNumber: string;
	companyName: string;
}




@inject("projectStore", "authStore", "appStore") @observer
export class AddProject extends React.Component<IProjectDashboardProps, IProjectDashboardState>{
	constructor(props, state){
		super(props, state);
		this.state = {
			"show": false,
			"projectName": "",
			"projectNumber": "",
			"companyName": ""
		};

		this.showPane = this.showPane.bind(this);
		this.hidePane = this.hidePane.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e: any, {name, value}){
		let props = {};
		props[name] = value;
		this.setState(props);
	}
	showPane(){
		this.setState({
			"show": true
		});
	}

	hidePane(){
		this.setState({
			"show": false
		});
	}

	async handleSave(ev){
		ev.stopPropagation();
		ev.preventDefault();
		let body = {
			"projectName": this.state.projectName,
			"projectNumber": this.state.projectNumber,
			"companyName": this.state.companyName
		};
		await this.props.projectStore.create(body);
		this.setState({
			"show": false,
			"projectName": "",
			"projectNumber": "",
			"companyName": ""
		});
	}


	render(){
		const { projectStore } = this.props;

		return(
		<div className="item">
			<Button icon="plus" className="jibunu-orange" onClick={this.showPane} />
			<EditorPane show={this.state.show} onClose={this.hidePane} title="Add Project">
				<Form onSubmit={this.handleSave}>
					<Form.Field>
						<Form.Input required type="text" label="Project Name" name="projectName" value={this.state.projectName} onChange={this.handleChange}  />
					</Form.Field>
					<Form.Field className="field">
						<Form.Input required type="text" label="Project Number" name="projectNumber" value={this.state.projectNumber} onChange={this.handleChange}  />
					</Form.Field>
					<Form.Field>
						<Form.Input required type="text" label="Company Name" name="companyName" value={this.state.companyName} onChange={this.handleChange}  />
					</Form.Field>
					<Form.Group>
						<Form.Button type="submit" icon color="green" labelPosition="left">
							<Icon name="save" />
							Save
						</Form.Button>
						<Form.Button icon color="blue" labelPosition="left" onClick={this.hidePane}>
							<Icon name="remove" />
							Close
						</Form.Button>
					</Form.Group>
				</Form>
			</EditorPane>
		</div>
		);
	}
}





// WEBPACK FOOTER //
// ./src/views/projects/add-project.tsx